export const SIZES = {
  NAME: 10,
  VALUE: 90,
};
